export const blobToFile = (blob: Blob, filename: string): File => {
    return new File([blob], filename, { type: blob.type });
};
export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = () => reject('Error converting blob to Base64');
        reader.readAsDataURL(blob);
    });
};
